<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {computed, ref} from "vue";
import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";
import {useMutation} from "@tanstack/vue-query";
import axios from "axios";
import {errorToast} from "@/composables/useToasts";

const props = defineProps({
  industriesJson: {
    type: String,
    required: true,
  }
});

const selectedIndustry = ref();
const formErrors = ref({});

const industryOptions = computed(() => JSON.parse(props.industriesJson));

const { mutate: submit, isPending, isSuccess } = useMutation({
  mutationFn: function () {
    formErrors.value = {};

    return axios.post('/shopify/setup', {
      industry: selectedIndustry.value,
    });
  },
  onSuccess: () => {
    window.location.href = '/shopify/onboarding';
  },
  onError: (error) => {
    if (error.response.status === 422) {
      formErrors.value = error.response.data.errors;
    } else {
      errorToast('Something went wrong');
    }
  },
});

</script>

<template>
  <div class="tw-flex tw-justify-center tw-items-center tw-min-h-full tw-w-full tw-flex-col">
    <div class="tw-flex tw-max-w-[60rem] tw-w-full tw-m-8 tw-gap-6">
      <div class="tw-flex tw-flex-col tw-gap-6 tw-w-full tw-grow">
        <div class="tw-flex tw-flex-col tw-gap-6">
          <h2 class="tw-text-2xl tw-font-semibold tw-text-neutral-900">
            Choose your industry
          </h2>
        </div>

        <CustomMultiselect
          v-model="selectedIndustry"
          :options="industryOptions"
          :validation-errors="formErrors?.industry"
          class="tw-relative"
          close-on-select
        />

        <DefaultButton
          :disabled="!selectedIndustry || isSuccess"
          :loading="isPending"
          @click="submit"
        >
          Continue
        </DefaultButton>
      </div>
    </div>
  </div>
</template>